import React from 'react';

function ArrowUp(props) {

    const imgStyle = { 
        width: props.width ? props.width : '10px',
        height: props.height ? props.height : '10px',
    };

    return (
        <img src='./assets/images/ArrowUp.png' style={imgStyle} />
    );
}

export default ArrowUp;
